import Vue from 'vue'
import axios from "axios"

Vue.use({
    install() {
        Vue.prototype.$watchContent = function (item) {
            const date_arrival = localStorage.getItem(document.location.pathname)
            item['date_arrival'] = date_arrival
            if (!(item['uri'] && item['url']))
                item['url'] = document.location.pathname

            let parsed = JSON.stringify(item)
            localStorage.setItem('item', parsed)

            /*  console.log("ITEM:", item)

            axios.post(`${config.appUrl}/api/watch-content`, item)
                  .then((response) => {
                      console.log("RESPONSE:", response)
                  })
              */
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/watchContent.js